import api from '../api';

const controller = 'crfContaContabilCc';

export interface ICreateCrfContaContabilCc {
  crfProjetoId: string;
  crfContaContabilId: string;
}

export const createCrfContaContabilCc = (model: ICreateCrfContaContabilCc) => api.put(`${controller}`, model);
